var play_icon_default = {
  "shadow": "g1O4r",
  "playIcon": "gv2P1"
};
export {
  play_icon_default as default
};
//# sourceMappingURL=play-icon-scss.js.map
